<template>
  <div>
    <font-awesome-icon
      :icon="['fas', 'arrow-up-right-from-square']"
      class="text-sky-900"
      @click="openModal"
    />
  </div>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div" @close="closeModal" class="relative z-10">
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black/25" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div
          class="flex min-h-full items-center justify-center p-4 text-center"
        >
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              class="w-full max-w-md transform overflow-hidden rounded-md bg-white p-4 text-left align-middle shadow-xl transition-all"
            >
              <DialogTitle as="h3">
                <div class="grid place-items-end">
                  <font-awesome-icon
                    :icon="['fas', 'xmark']"
                    class="h-6 w-6 text-gray-400"
                    @click="closeModal"
                  />
                </div>

                <div class="grid justify-items-center font-inter leading-6">
                  <p class="text-xl font-semibold text-orange-600">
                    {{ issue.VehicleID.NumberPlate }}
                  </p>
                  <p class="text-gray-500 font-light text-sm">Vehicle Issue</p>
                </div>
              </DialogTitle>
              <div class="mt-5 border p-4">
                <div>
                  <div class="flex justify-between font-inter">
                    <p class="text-black text-sm font-bold">Issue Status</p>
                    <p
                      class="text-sm"
                      :class="
                        issue.IssueStatus == 'Open'
                          ? 'text-red-700'
                          : 'text-green-700'
                      "
                    >
                      {{ issue.IssueStatus }}
                    </p>
                  </div>
                  <div class="flex justify-between font-inter my-3">
                    <p class="text-black text-sm font-bold">Date Reported</p>
                    <p class="text-gray-500 text-sm">
                      {{
                        $store.getters.getTimestampzFormattedDate(
                          issue.DateReported
                        )
                      }}
                    </p>
                  </div>
                </div>
                <div class="font-inter">
                  <p class="text-black text-sm font-bold">Issue Summary</p>
                  <p class="text-gray-500 text-sm mt-2">
                    {{ issue.IssueSummary }}
                  </p>
                </div>
                <div class="font-inter mt-3">
                  <p class="text-black text-sm font-bold">Issue Description</p>
                  <p class="text-gray-500 text-sm mt-1">
                    {{ issue.IssueDescription }}
                  </p>
                </div>
                <div v-if="issue.ImageUrl" class="font-inter mt-3">
                  <p class="text-black text-sm font-bold mb-2">Image</p>
                  <a
                    :href="issue.ImageUrl"
                    target="_blank"
                    class="flex justify-end outline-none text-sm font-inter my-2"
                    >Download Image</a
                  >
                  <img :src="issue.ImageUrl" class="w-full h-96 object-cover" />
                </div>
                <div v-else>
                  <p class="text-black text-sm font-bold mb-2">Image</p>
                  <p>N/A</p>
                </div>
                <div
                  v-if="issue.IssueStatus == 'Open'"
                  class="flex justify-end"
                >
                  <button
                    v-if="!isLoading"
                    @click="closeVehicleIssue"
                    class="uppercase font-inter bg-green-700 text-white rounded mt-4 py-2 px-2 text-sm"
                  >
                    close issue
                  </button>
                  <div v-else>
                    <svg
                      aria-hidden="true"
                      class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-orange-600"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
  DialogTitle,
} from "@headlessui/vue";
</script>
<script>
import DataRepository from "@/infrastructure/services/DataRepository";
export default {
  emits: ["issueClosed"],
  props: {
    issue: {
      required: true,
      default: [],
    },
  },
  data() {
    return {
      isLoading: false,
      isOpen: false,
      vehicleIssueJsonData: {
        IssueStatus: "Closed",
        LastEditedBy: this.$store.getters.getUserData.id,
        EditedAt: this.$store.getters.getCurrentTimestampZDate,
      },
    };
  },
  methods: {
    closeModal() {
      this.isOpen = false;
    },
    openModal() {
      this.isOpen = true;
    },
    async closeVehicleIssue() {
      this.isLoading = true;
      const closeVehicleIssueResponse = await DataRepository.closeVehicleIssue(
        this.vehicleIssueJsonData,
        this.issue.IssueID
      );
      this.$emit("issueClosed", closeVehicleIssueResponse);
      this.isLoading = false;
      this.closeModal();
    },
  },
};
</script>
